import { Controller } from "@hotwired/stimulus";
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock-upgrade";
export default class extends Controller {
  static targets = ["panel"];

  initialize() {
    this.active = false;
  }

  togglePanel(e, variant) {
    if (this.hasPanelTarget) {
      if (this.panelTarget.classList.contains("panel--active")) {
        this.active = false;
      } else {
        this.active = true;
      }
    }
    e?.preventDefault();
    if (this.active) {
      variant && this.buildItem(variant);
      if (this.hasPanelTarget) {
        this.panelTarget.classList.add("panel--active");
      }
    } else {
      if (this.hasPanelTarget) {
        this.panelTarget.classList.remove("panel--active");
      } else {
        document.querySelector(".panel").classList.remove("panel--active");
      }
      variant && this.clearItem();

      if (document.querySelector('[data-quickcart-target="lineItems"]')) {
        enableBodyScroll(
          document.querySelector('[data-quickcart-target="lineItems"]')
        );
      }
    }
  }

  // @TODO: Neaten Up
  async submitNotify(e) {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const res = await fetch(`${e.currentTarget.action}`, {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        const data = await res.json();
        if (data.success) {
          document.querySelector(".notify-form-foot").innerHTML =
            '<p style="color: #ffffff; margin-bottom: 1.6rem;">We have received your email address and will get in touch when this product is back in stock.</p>';
        }
      }
      console.error("There was an error", res);
    } catch (err) {
      console.error("There was an error", err);
    }
  }
}
